module.exports = __webpack_public_path__ + "static/media/icon-gp-pl.bc4cf709.png";